import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Grid } from "@material-ui/core";
import { COOKIE_POLICY } from "../../routes/RouteConstants";
import { logEvents } from "../../redux/commonActions";
import {
  PUBLIC_FOOTER_ABOUT,
  PUBLIC_FOOTER_SEEKER_LOGIN,
  PUBLIC_FOOTER_COOKIE_POLICY
} from "../../services/webengage/webEngageConstants";
import { recruiterToSeekerUTM } from "../../services/utils";
import { ABOUT_US_URL, INFOEDGE_URL } from "../../services/constants";

const Company = props => {
  function handleClick(url, evntType, isNewWindow = false) {
    props.logEvents(evntType);
    isNewWindow ? window.open(url, "_blank") : (window.location = `${url}`);
  }
  const { classes } = props;
  return (
    <Grid item className={classes.footerItem}>
      <div className={classes.heading}>Company</div>
      <span
        className={classes.subHeading}
        onClick={() => handleClick(ABOUT_US_URL, PUBLIC_FOOTER_ABOUT, true)}
      >
        About Us
      </span>
      <span
        className={classes.subHeading}
        onClick={() =>
          handleClick(COOKIE_POLICY, PUBLIC_FOOTER_COOKIE_POLICY, true)
        }
      >
        Cookie Policy
      </span>
      <span
        className={classes.subHeading}
        onClick={() =>
          handleClick(recruiterToSeekerUTM(), PUBLIC_FOOTER_SEEKER_LOGIN, true)
        }
      >
        Job Seeker Login
      </span>
    </Grid>
  );
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ logEvents }, dispatch);
};

export default connect(null, mapDispatchToProps)(Company);
